/**
 * Internal dependencies
 */
import '../inc/blocks/data-capture-form/src/frontend';
import '../inc/blocks/donation-form/src/frontend';
import '../inc/blocks/receipt/src/frontend';
